export function LoadingState({ label = 'Loading operational data' }: { label?: string }) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <span className="loading-rule" />
      <span>{label}</span>
    </div>
  )
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="error-state" role="alert">
      <strong>Data could not be loaded</strong>
      <span>{message} Refresh the page or choose another reporting period.</span>
    </div>
  )
}

export function EmptyState() {
  return (
    <div className="empty-state">
      <strong>No covered observations in this range</strong>
      <span>Choose a period between 5 January and 3 February 2026.</span>
    </div>
  )
}
